import React, { useState } from 'react';
import Layout from './components/Layout';
import Header from './components/Header';
import { Chip, ChoiceChipGroup, FilterChipGroup } from '../../components/common/Chip';
import { Playground, Control } from './components/Playground';
import styles from './Chip.module.css';

const demoChips = [
  { value: 'chip1', label: '칩 1' },
  { value: 'chip2', label: '칩 2' },
  { value: 'chip3', label: '칩 3' },
];

const ChipPlayground = () => {
  const [chipConfig, setChipConfig] = useState({
    type: 'choice',
    disabled: false,
    selectedValue: '',
    selectedValues: [],
  });

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setChipConfig(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleChoiceSelect = (newValue) => {
    setChipConfig(prev => ({
      ...prev,
      selectedValue: newValue
    }));
  };

  const handleFilterSelect = (newValue) => {
    setChipConfig(prev => ({
      ...prev,
      selectedValues: newValue
    }));
  };

  return (
    <Playground
      controls={
        <>
          <Control
            type="radio"
            label="타입"
            name="type"
            value={chipConfig.type}
            onChange={handleChange}
            options={[
              { value: 'choice', label: 'Choice' },
              { value: 'filter', label: 'Filter' },
            ]}
          />
          <Control
            type="checkbox"
            label="비활성화"
            name="disabled"
            checked={chipConfig.disabled}
            onChange={handleChange}
          />
        </>
      }
      preview={
        chipConfig.type === 'choice' ? (
          <ChoiceChipGroup
            chips={demoChips}
            disabled={chipConfig.disabled}
            value={chipConfig.selectedValue}
            onChange={handleChoiceSelect}
          />
        ) : (
          <FilterChipGroup
            chips={demoChips}
            disabled={chipConfig.disabled}
            value={chipConfig.selectedValues}
            onChange={handleFilterSelect}
          />
        )
      }
    />
  );
};

const ChipDemo = () => {
  const [selectedChoice, setSelectedChoice] = useState('chip1');
  const [selectedFilters, setSelectedFilters] = useState(['chip1']);

  return (
    <Layout>
      <div className={styles.container}>
        <Header 
          title="칩"
          description="정보를 간단하게 표시하고 선택할 수 있는 칩 컴포넌트입니다."
        />

        <ChipPlayground />

        <section className={styles.demoSection}>
          <h2>타입</h2>
          <div className={styles.demoGrid}>
            <div className={styles.demoWrapper}>
              <h3>Choice</h3>
              <ChoiceChipGroup
                chips={demoChips}
                value={selectedChoice}
                onChange={setSelectedChoice}
              />
            </div>

            <div className={styles.demoWrapper}>
              <h3>Filter</h3>
              <FilterChipGroup
                chips={demoChips}
                value={selectedFilters}
                onChange={setSelectedFilters}
              />
            </div>
          </div>
        </section>

        <section className={styles.demoSection}>
          <h2>상태</h2>
          <div className={styles.demoGrid}>
            <div className={styles.demoWrapper}>
              <h3>기본</h3>
              <ChoiceChipGroup
                chips={demoChips}
                value={selectedChoice}
                onChange={setSelectedChoice}
              />
            </div>

            <div className={styles.demoWrapper}>
              <h3>비활성화</h3>
              <ChoiceChipGroup
                chips={demoChips}
                disabled
                value={selectedChoice}
              />
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default ChipDemo; 